<template>
  <el-form :value="form" label-width="80px" class="setting-header" label-position="left">
    <el-form-item>
      <template slot="label">
        <span style="line-height:60px">图表类型</span>
      </template>
      <div class="svg-list">
        <el-radio-group v-model="chart.type" style="display:flex">
          <el-radio-button
            v-for="(chart, index) in chartList"
            :key="index"
            :label="chart.value"
            v-show="!chart.disabled"
          >
            <el-tooltip class="item" effect="dark" :content="chart.name" placement="bottom">
              <svg-icon :icon-class="'chart_' + chart.value" class="svg-item"></svg-icon>
            </el-tooltip>
          </el-radio-button>
        </el-radio-group>
      </div>
    </el-form-item>
    <template
      v-if="
        ['basic-bar', 'line', 'smoothed-line', 'area-chart', 'stacked-basic-bar'].includes(
          chart.type
        )
      "
    >
      <el-form-item label="X轴">
        <div class="field-group">
          <div class="field-list">
            <draggable
              :group="{
                name: 'x-control',
                put: getXPut
              }"
              v-model="chart.xAxisList"
              class="sort-list"
            >
              <template v-if="chart.xAxisList && chart.xAxisList.length">
                <field-item
                  v-for="(item, index) in chart.xAxisList"
                  :key="item.id"
                  :axis="item"
                  setXType
                  type="x"
                  :chartType="chart.type"
                  @delete="deleteItem(chart.xAxisList, index)"
                ></field-item>
              </template>
              <div
                v-else
                :class="canSetting.x === 'true' ? 'can-setting' : 'normal-setting'"
                class="group-hint"
              >
                拖动左侧字段至此处
              </div>
            </draggable>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="Y轴">
        <div class="field-group">
          <div class="field-list">
            <draggable
              :group="{
                name: 'y-control',
                put: getYPut
              }"
              v-model="chart.yAxisList"
              class="sort-list"
            >
              <template v-if="chart.yAxisList && chart.yAxisList.length">
                <field-item
                  v-for="(item, index) in chart.yAxisList"
                  :key="item.id"
                  :axis="item"
                  type="y"
                  :x-axis-list="chart.xAxisList"
                  :chartType="chart.type"
                  @delete="deleteItem(chart.yAxisList, index)"
                  @update="updateComputedField(item, index)"
                ></field-item>
              </template>
              <div
                v-else
                :class="canSetting.y === 'true' ? 'can-setting' : 'normal-setting'"
                class="group-hint"
              >
                拖动左侧字段至此处
              </div>
            </draggable>
            <el-button class="create-computed" @click="createComputedField">
              <svg-icon icon-class="chart_fx" class="fx"></svg-icon>
            </el-button>
          </div>
        </div>
      </el-form-item>
    </template>
    <template v-else-if="['ring-diagram', 'pie'].includes(chart.type)">
      <el-form-item label="类别">
        <div class="field-group">
          <div class="field-list">
            <draggable
              :group="{
                name: 'x-control',
                put: getXPut
              }"
              v-model="chart.xAxisList"
              class="sort-list"
            >
              <template v-if="chart.xAxisList && chart.xAxisList.length">
                <field-item
                  v-for="(item, index) in chart.xAxisList"
                  :key="item.id"
                  :axis="item"
                  setXType
                  type="x"
                  :chartType="chart.type"
                  @delete="deleteItem(chart.xAxisList, index)"
                ></field-item>
              </template>
              <div
                v-else
                :class="canSetting.x === 'true' ? 'can-setting' : 'normal-setting'"
                class="group-hint"
              >
                拖动左侧字段至此处
              </div>
            </draggable>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="指标">
        <div class="field-group">
          <div class="field-list">
            <draggable
              :group="{
                name: 'y-control',
                put: getYPut
              }"
              v-model="chart.yAxisList"
              class="sort-list"
            >
              <template v-if="chart.yAxisList && chart.yAxisList.length">
                <field-item
                  v-for="(item, index) in chart.yAxisList"
                  :key="item.id"
                  :axis="item"
                  type="y"
                  :x-axis-list="chart.xAxisList"
                  :chartType="chart.type"
                  @delete="deleteItem(chart.yAxisList, index)"
                  @update="updateComputedField(item, index)"
                ></field-item>
              </template>
              <div
                v-else
                :class="canSetting.y === 'true' ? 'can-setting' : 'normal-setting'"
                class="group-hint"
              >
                拖动左侧字段至此处
              </div>
            </draggable>
            <el-button class="create-computed" @click="createComputedField">
              <svg-icon icon-class="chart_fx" class="fx"></svg-icon>
            </el-button>
          </div>
        </div>
      </el-form-item>
    </template>
    <template v-else-if="['indicator'].includes(chart.type)">
      <el-form-item label="指标">
        <div class="field-group">
          <div class="field-list">
            <draggable
              :group="{
                name: 'y-control',
                put: getYPut
              }"
              v-model="chart.yAxisList"
              class="sort-list"
            >
              <template v-if="chart.yAxisList && chart.yAxisList.length">
                <field-item
                  v-for="(item, index) in chart.yAxisList"
                  :key="item.id"
                  :axis="item"
                  type="y"
                  :x-axis-list="chart.xAxisList"
                  :chartType="chart.type"
                  @delete="deleteItem(chart.yAxisList, index)"
                  @update="updateComputedField(item, index)"
                ></field-item>
              </template>
              <div
                v-else
                :class="canSetting.y === 'true' ? 'can-setting' : 'normal-setting'"
                class="group-hint"
              >
                拖动左侧字段至此处
              </div>
            </draggable>
            <el-button class="create-computed" @click="createComputedField">
              <svg-icon icon-class="chart_fx" class="fx"></svg-icon>
            </el-button>
          </div>
        </div>
      </el-form-item>
    </template>
    <template v-else-if="['cross-table'].includes(chart.type)">
      <el-form-item label="维度">
        <div class="field-group">
          <div class="field-list">
            <draggable group="x-control" v-model="chart.xAxisList" class="sort-list">
              <template v-if="chart.xAxisList && chart.xAxisList.length">
                <field-item
                  v-for="(item, index) in chart.xAxisList"
                  :key="item.id"
                  :axis="item"
                  setXType
                  :chartType="chart.type"
                  :is-last="index + 1 === chart.xAxisList.length"
                  type="x"
                  @delete="deleteItem(chart.xAxisList, index)"
                ></field-item>
              </template>
              <div
                v-else
                :class="canSetting.x === 'true' ? 'can-setting' : 'normal-setting'"
                class="group-hint"
              >
                拖动左侧字段至此处
              </div>
            </draggable>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="指标">
        <div class="field-group">
          <div class="field-list">
            <draggable group="y-control" v-model="chart.yAxisList" class="sort-list">
              <template v-if="chart.yAxisList && chart.yAxisList.length">
                <field-item
                  v-for="(item, index) in chart.yAxisList"
                  :key="item.id"
                  :axis="item"
                  type="y"
                  :x-axis-list="chart.xAxisList"
                  :chartType="chart.type"
                  @delete="deleteItem(chart.yAxisList, index)"
                  @update="updateComputedField(item, index)"
                ></field-item>
              </template>
              <div
                v-else
                :class="canSetting.y === 'true' ? 'can-setting' : 'normal-setting'"
                class="group-hint"
              >
                拖动左侧字段至此处
              </div>
            </draggable>
            <el-button class="create-computed" @click="createComputedField">
              <svg-icon icon-class="chart_fx" class="fx"></svg-icon>
            </el-button>
          </div>
        </div>
      </el-form-item>
    </template>
    <template v-else-if="['funnel'].includes(chart.type)">
      <el-form-item label="X轴">
        <div class="field-group">
          <div class="field-list">
            <draggable
              :group="{
                name: 'x-control',
                put: getXPut
              }"
              v-model="chart.xAxisList"
              class="sort-list"
            >
              <template v-if="chart.xAxisList && chart.xAxisList.length">
                <field-item
                  v-for="(item, index) in chart.xAxisList"
                  :key="item.id"
                  :axis="item"
                  setXType
                  type="x"
                  :chartType="chart.type"
                  @delete="deleteItem(chart.xAxisList, index)"
                ></field-item>
              </template>
              <div
                v-else
                :class="canSetting.x === 'true' ? 'can-setting' : 'normal-setting'"
                class="group-hint"
              >
                拖动左侧字段至此处
              </div>
            </draggable>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="Y轴">
        <div class="field-group">
          <div class="field-list">
            <draggable
              :group="{
                name: 'y-control',
                put: getYPut
              }"
              v-model="chart.yAxisList"
              class="sort-list"
            >
              <template v-if="chart.yAxisList && chart.yAxisList.length">
                <field-item
                  v-for="(item, index) in chart.yAxisList"
                  :key="item.id"
                  :axis="item"
                  type="y"
                  :x-axis-list="chart.xAxisList"
                  :chartType="chart.type"
                  @delete="deleteItem(chart.yAxisList, index)"
                  @update="updateComputedField(item, index)"
                ></field-item>
              </template>
              <div
                v-else
                :class="canSetting.y === 'true' ? 'can-setting' : 'normal-setting'"
                class="group-hint"
              >
                拖动左侧字段至此处
              </div>
            </draggable>
          </div>
        </div>
      </el-form-item>
    </template>
    <template v-else-if="['map'].includes(chart.type)">
      <el-form-item label="区域">
        <div class="field-group">
          <div class="field-list">
            <draggable
              :group="{
                name: 'x-control',
                put: getXPut
              }"
              v-model="chart.xAxisList"
              class="sort-list"
            >
              <template v-if="chart.xAxisList && chart.xAxisList.length">
                <field-item
                  v-for="(item, index) in chart.xAxisList"
                  :key="item.id"
                  :axis="item"
                  setXType
                  :chartType="chart.type"
                  type="x"
                  @delete="deleteItem(chart.xAxisList, index)"
                ></field-item>
              </template>
              <div
                v-else
                :class="canSetting.x === 'true' ? 'can-setting' : 'normal-setting'"
                class="group-hint"
              >
                拖动左侧字段至此处
              </div>
            </draggable>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="指标">
        <div class="field-group">
          <div class="field-list">
            <draggable group="y-control" v-model="chart.yAxisList" class="sort-list">
              <template v-if="chart.yAxisList && chart.yAxisList.length">
                <field-item
                  v-for="(item, index) in chart.yAxisList"
                  :key="item.id"
                  :axis="item"
                  type="y"
                  :x-axis-list="chart.xAxisList"
                  :chartType="chart.type"
                  @delete="deleteItem(chart.yAxisList, index)"
                  @update="updateComputedField(item, index)"
                ></field-item>
              </template>
              <div
                v-else
                :class="canSetting.y === 'true' ? 'can-setting' : 'normal-setting'"
                class="group-hint"
              >
                拖动左侧字段至此处
              </div>
            </draggable>
          </div>
        </div>
      </el-form-item>
    </template>
    <template v-else-if="['bar', 'stacked-bar'].includes(chart.type)">
      <el-form-item label="X轴">
        <div class="field-group">
          <div class="field-list">
            <draggable
              :group="{
                name: 'y-control',
                put: getYPut
              }"
              v-model="chart.yAxisList"
              class="sort-list"
            >
              <template v-if="chart.yAxisList && chart.yAxisList.length">
                <field-item
                  v-for="(item, index) in chart.yAxisList"
                  :key="item.id"
                  :axis="item"
                  type="y"
                  :x-axis-list="chart.xAxisList"
                  :chartType="chart.type"
                  @delete="deleteItem(chart.yAxisList, index)"
                  @update="updateComputedField(item, index)"
                ></field-item>
              </template>
              <div
                v-else
                :class="canSetting.y === 'true' ? 'can-setting' : 'normal-setting'"
                class="group-hint"
              >
                拖动左侧字段至此处
              </div>
            </draggable>
            <el-button class="create-computed" @click="createComputedField">
              <svg-icon icon-class="chart_fx" class="fx"></svg-icon>
            </el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="Y轴">
        <div class="field-group">
          <div class="field-list">
            <draggable
              :group="{
                name: 'x-control',
                put: getXPut
              }"
              v-model="chart.xAxisList"
              class="sort-list"
            >
              <template v-if="chart.xAxisList && chart.xAxisList.length">
                <field-item
                  v-for="(item, index) in chart.xAxisList"
                  :key="item.id"
                  :axis="item"
                  setXType
                  type="x"
                  :chartType="chart.type"
                  @delete="deleteItem(chart.xAxisList, index)"
                ></field-item>
              </template>
              <div
                v-else
                :class="canSetting.x === 'true' ? 'can-setting' : 'normal-setting'"
                class="group-hint"
              >
                拖动左侧字段至此处
              </div>
            </draggable>
          </div>
        </div>
      </el-form-item>
    </template>
    <el-form-item label="条件">
      <condition-list
        :conditions="filledPreCondition"
        :search-sheet="searchSheet"
        ref="conditionList"
        from="sheet_frontend"
        class="condition-chart"
      ></condition-list>
    </el-form-item>
    <computed-field-dialog
      ref="computedFieldDialog"
      @update="updateComputed"
      @create="createComputed"
      :axis-list="chart.yAxisList"
    ></computed-field-dialog>
  </el-form>
</template>
<script>
import ConditionList from "@/components/UIComponents/ConditionList/ConditionList"
import draggable from "vuedraggable"
import FieldItem from "./fieldItem.vue"
import { chartList } from "./static"
import { getSheet } from "@/api/sheet/sheet"
import ComputedFieldDialog from "./ComputedFieldDialog.vue"
import { transFieldControl } from "@/utils/sheet"

export default {
  name: "setting-header",
  components: { ConditionList, FieldItem, draggable, ComputedFieldDialog },
  data() {
    return {
      chartList,
      form: {},
      filledPreCondition: [],
      searchSheet: {
        controls: "",
        sheetId: ""
      },
      axisIndex: 0
    }
  },
  created() {
    this.refresh()
  },
  props: {
    chart: Object,
    canSetting: Object
  },
  methods: {
    refresh() {
      if (
        [
          "basic-bar",
          "stacked-basic-bar",
          "bar",
          "stacked-bar",
          "line",
          "smoothed-line",
          "area-chart"
        ].includes(this.chart.type)
      ) {
        this.chartList.forEach(chart => {
          if (
            ![
              "basic-bar",
              "stacked-basic-bar",
              "bar",
              "stacked-bar",
              "line",
              "smoothed-line",
              "area-chart"
            ].includes(chart.value)
          )
            chart.disabled = true
          else chart.disabled = false
        })
      } else if (["ring-diagram", "pie"].includes(this.chart.type)) {
        this.chartList.forEach(chart => {
          if (!["ring-diagram", "pie"].includes(chart.value)) chart.disabled = true
          else chart.disabled = false
        })
      } else if (["indicator"].includes(this.chart.type)) {
        this.chartList.forEach(chart => {
          if (!["indicator"].includes(chart.value)) chart.disabled = true
          else chart.disabled = false
        })
      } else if (["funnel"].includes(this.chart.type)) {
        this.chartList.forEach(chart => {
          if (!["funnel"].includes(chart.value)) chart.disabled = true
          else chart.disabled = false
        })
      } else if (["cross-table"].includes(this.chart.type)) {
        this.chartList.forEach(chart => {
          if (!["cross-table"].includes(chart.value)) chart.disabled = true
          else chart.disabled = false
        })
      } else if (["map"].includes(this.chart.type)) {
        this.chartList.forEach(chart => {
          if (!["map"].includes(chart.value)) chart.disabled = true
          else chart.disabled = false
        })
      }
      this.filledPreCondition = this.chart.filters
      if (this.chart.sheetId) {
        getSheet(this.chart.sheetId).then(res => {
          this.searchSheet = {
            controls: res.controls.map(c => transFieldControl(c)),
            sheetId: res.sheetId
          }
        })
      }
    },
    deleteItem(list, index) {
      list.splice(index, 1)
    },
    updateComputed(item) {
      this.chart.yAxisList[this.axisIndex] = item
    },
    createComputed(item) {
      item.hidden = false
      this.chart.yAxisList.push(item)
    },
    createComputedField() {
      this.$refs.computedFieldDialog.open()
    },
    updateComputedField(val, index) {
      if (!val.expression) return
      this.axisIndex = index
      this.$refs.computedFieldDialog.open(val)
    },
    getXPut(to, from) {
      let isSameGroup = from.options.group.name === to.options.group.name
      let extra = null
      switch (this.chart.type) {
        case "basic-bar":
        case "line":
        case "smoothed-line":
        case "area-chart":
        case "bar":
          extra =
            this.chart.xAxisList &&
            this.chart.xAxisList.length < 2 &&
            this.chart.yAxisList &&
            this.chart.yAxisList.filter(yAxis => !yAxis.hidden).length <= 1
          break
        case "stacked-basic-bar":
        case "ring-diagram":
        case "pie":
        case "map":
        case "stacked-bar":
          extra = this.chart.xAxisList && this.chart.xAxisList.length < 1
          break
        case "funnel":
          extra =
            this.chart.yAxisList &&
            this.chart.yAxisList.filter(yAxis => !yAxis.hidden).length < 2 &&
            this.chart.xAxisList &&
            this.chart.xAxisList.length < 1
          break
      }
      return isSameGroup && extra
    },
    getYPut(to, from) {
      let isSameGroup = from.options.group.name === to.options.group.name
      return isSameGroup
    }
  }
}
</script>
<style lang="scss" scoped>
.setting-header {
  .el-form-item {
    margin-bottom: 0;
    border-bottom: 1px solid rgba(220, 223, 230, 0.8);
  }
  .svg-list {
    align-items: center;
    display: flex;
    height: 60px;
    .svg-item {
      height: 28px;
      width: 28px;
      padding: 5px;
    }
  }
  .field-group {
    display: flex;
    .field-list {
      height: 100%;
      width: calc(100% - 60px);
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      box-sizing: border-box;
      .sort-list {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
      }
    }
    &:hover {
      .add-button {
        opacity: 1;
      }
    }
    .add-button {
      opacity: 0;
    }
    .delete-button {
      color: #ff7373;
    }
    .group-hint {
      width: 162px;
      height: 34px;
      margin-bottom: 4px;
      border-radius: 4px;
      text-align: center;
      margin-top: 3px;
      margin-right: 5px;
      line-height: 34px;
      ::v-deep .el-menu-item {
        display: none;
      }
    }
  }
  .can-setting {
    color: #1989fa;
    background: rgba(181, 217, 253, 0.3);
    border: 1px dashed #1989fa;
  }
  .normal-setting {
    background: #ffffff;
    border: 1px dashed #dcdfe6;
    color: #c0c4cc;
  }
  .field-item {
    margin-right: 5px;
  }
  .condition-chart {
    text-align: left;
    width: 338px;
    margin-bottom: 6px;
    ::v-deep .condition-item-wrapper {
      padding-top: 6px !important;
      width: 360px;
    }
    ::v-deep .add-condition-btn {
      margin-top: 6px !important;
    }
    ::v-deep .condition-item {
      width: 338px;
    }
    ::v-deep .tag-and {
      top: 2px !important;
    }
  }
  .create-computed {
    width: 36px;
    height: 36px;
    margin-top: 3px;
    margin-bottom: 4px;
    padding: unset;
    display: block;
  }
  .fx {
    font-size: 16px;
  }
}
</style>
